<template>
  <div class="wrapper">
    <div class="shop-container">
      <div class="nav">
        <router-link to="home">{{$t('home')}}</router-link>
        <span>></span>
        <span>Instruction Manual</span>
      </div>
      <div class="main"  v-loading="loading">
        <div class="l bgw">
          <!-- 帮助中心 -->
          <h6 @click="gocenter">Instruction Manual</h6>
          <div class="list-wrap" v-for="(item,index) in list" :key="index" @click="typeCLick(item)">
            <div class="classify">
              <img src="http://www.sanlida.cn/templates/pccommon/images/new/article_12.jpg" alt="">
              <h3 class="title">{{item.type_name}}</h3> 
            </div>
          </div>
        </div>
        <div class="r">
          <div class="bgw">
            <template v-if="showDetail">
              <div class="article-nav">
                <div v-for="(item,index) in detail.article_type" :key="index">
                  <div v-for="(father,key) in item.father" :key="key">
                    <span class="artlink">{{father.type_name}}</span> >
                    <a href="javascript:;" class="artlink" @click="getArticleList(item.id)">{{item.type_name}}</a>
                  </div>
                </div>
              </div>
              <div class="top-head">
                {{detail.title}}
                <div class="info">
                  <span>
                    <!-- {{detail.ctime}} -->
                  </span>
                </div>
              </div>
              <template>
                <div v-html="detail.content" style="line-height:20px;"></div>
              </template>
            </template>
            <template v-else>
              <ul class="art-list">
                <li v-for="(item,index) in articleList" :key="index">
                  <div class="media">
                    <div class="media-body">
                      <a href="javascript:;" @click="getArticleDetail(item)">
                        <h4>{{item.title}}</h4>
                      </a>
                      <div class="info">
                        <!-- <span>  {{newTime(item.ctime)}} </span> -->
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <Pagination :totalPage="totalPage" :limit="form.limit" 
              @changePage="handOrderMore" v-if="totalPage>0"></Pagination>
            </template>
          </div>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'

export default {
  components: { Pagination },
  inject: ['reload'],
  data() {
    return {
      form: {
        limit: 10,
        page: 1
      },
      articleList: [],
      totalPage: 1,
      showDetail: false,

      list: [],
      articleList: [],
      detail: {},
      totalPage: 0,
      showDetail: false,
      artClassId: '',
      hotList: [],
      artId: 0,
      where: {},
      loading: false,
      typeId: ''
    }
  },
  created() {
    let id = 
    this.typeId = this.$route.query.id || ''
    this.getArticleNav()

    if(this.typeId) {
      this.getTypeList()
    } else {
      this.getList()
    }
  },

  watch: {
    $route(v1) {
      console.log(12321321, v1)
    }
  },
  methods: {
    getTypeList() {
      this.$api.manualsGetList({...this.form, id: this.typeId}).then(res => {
        if(res.status) {
          this.articleList = res.data.list.article
          // this.totalPage = Math.ceil(
          //   Number(res.data.count) / Number(this.form.limit)
          // )
        }
      })
    },
    getList() {
      this.$api.manualsGetArticleList(this.form).then(res => {
        if(res.status) {
          this.articleList = res.data.list
          this.totalPage = Math.ceil(
            Number(res.data.count) / Number(this.form.limit)
          )
        }
      })
    },
    // 去帮助中心
    gocenter() {
      this.$router.push({
        path: '/help'
      })
    },
    // 分页
    handOrderMore(val) {  
      this.form.page = val
      // this.getArticleList(this.artId)
    },

    //获取文章详情
    getArticleDetail(v) {
      this.$router.replace({
        path: '/bookdetail',
        query: {
          id_type: v.type_id,
          id: v.id
        }
      })
    },
    // 获取文章所有分类
    getArticleNav() {
      this.$api.manualsGetList().then(res => {
        if (res.status) {
          this.list = res.data.list
        }
      })
    },
    typeCLick(val) {
      this.$router.replace({
        path: '/books',
        query: {
          id: val.id
        }
      })
      this.reload()
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.wrapper {
  .nav {
    @include line-height(40px);
    font-size: 12px;
    span {
      padding: 0 4px;
      font-size: #757575;
    }
    a:hover {
      color: #000;
    }
  }
  .main {
    display: flex;
    margin-bottom: 20px;
    flex-direction: row-reverse;
    .l {
      width: 234px;
      margin-left: 20px;
      // padding: 40px 0;
      h6 {
        width: 175px;
        color: #e7442f;
        border-bottom: 1px solid #f0f0f0;
        font-weight: normal;
        font-size: 18px;
        height: 45px;
        overflow: hidden;
        padding-left: 25px;
        line-height: 47px;
        background: #fff url('http://www.sanlida.cn/templates/pccommon/images/new/article_03.jpg') no-repeat 20px 16px;
        cursor: pointer;
      }
      .article {
        padding-left: 20px;
        img {
          height: 20px;
          vertical-align: bottom;
        }
        h2 {
          font-size: 17px;
          display: inline-block;
        }
      }

      .list-wrap {
        // margin-bottom: 20px;

        .classify {
          padding-left: 30px;
          cursor: pointer;
          img {
            width: 4px;
            vertical-align: middle;
            margin-right: 8px;
          }
          .title {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: #333;
          }
        }

        ul {
          padding-left: 20px;
          li {
            padding-left: 48px;
            height: 32px;
            line-height: 32px;
            color: #757575;
            cursor: pointer;
            &.active {
              color: $theme-color;
            }
            a:hover {
              color: $theme-color;
            }
            a.router-link-active {
              color: $theme-color;
            }
          }
        }
      }
      .xian {
        border-top: 1px solid #ccc;
        width: 190px;
        text-align: center;
        margin-left: 25px;
        margin-bottom: 20px;
      }
      .recommend {
        padding: 10px;
        .title {
          // font-size: 17px;
          // color: #555;
          img {
            height: 20px;
            vertical-align: bottom;
          }
          h2 {
            font-size: 17px;
            display: inline-block;
          }
        }
        .reList {
          margin-top: 10px;
          list-style: none;
          color: rgb(85, 85, 85);
          border: 1px solid #e4eaec;
          border-radius: 4px;
          cursor: pointer;
          .reItem {
            padding: 10px 10px 10px 15px;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            display: flex;
            .recommendTitle {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            img {
              width: 20px;
              vertical-align: middle;
            }
            span {
             
              line-height: 20px;
            }
            .title {
              white-space: nowrap;
              overflow:hidden; 
              text-overflow:ellipsis;
              // display:-webkit-box; 
              // -webkit-box-orient:vertical;
              // -webkit-line-clamp:2;
            }
          }
        }
      }
    }
    .r {
      flex: 1;
      .bgw {
        padding: 24px;
        min-height: 600px;
        
        .article-nav {
          height: 30px;
          line-height: 30px;
          border-bottom: 1px dashed $border;
          margin-bottom: 20px;
          a.artlink {
            &:hover {
              color: $theme-color;
            }
          }
        }
        .top-head {
          font-size: 24px;
          font-weight: 400;
          line-height: 40px;
          color: #757575;
          margin-bottom: 10px;
          border-bottom: 1px solid rgb(238, 238, 238);
          .info {
            font-size: 14px;
            color: #76838f;
            span {
              margin-right: 10px;
              img {
                width: 15px;
                vertical-align: middle;
              }
            }
          }
        }
      }
      .art-list {
        li {
          padding: 20px 10px;
          border-bottom: 1px solid rgb(238, 238, 238);
          a {
            display: block;
            // padding: 10px;
            cursor: pointer;
            &:hover {
              color: $theme-color;
            }
          }
          .media {
            .media-left {
              width: 100px;
              height: 100px;
              display: inline-block;
              padding-right: 20px;
              vertical-align: top;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .media-body {
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              h4 {
                color: #333333;
                // margin-bottom: 20px;
                font-size: 16px;
              }
              .des {
                font-size: 14px;
                margin-bottom: 20px;
                color: #76838f;
                line-height: 20px;
              }
              .info {
                font-size: 14px;
                color: #76838f;
                span {
                  margin-right: 10px;
                  img {
                    width: 15px;
                    vertical-align: middle;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.recommendCover {
  display: inline-block;
  width: 50px;
  height: 50px;
  vertical-align: top;
  img {
    width: 50px !important;
  }
}
.recommendTitle {
  display: inline-block;
  width: 131px;
  margin-left: 5px;
}
</style>

<style lang="scss">

.el-loading-parent--hidden {
  overflow: initial !important;
}
</style>